export const months = [
  'Янв',
  'Фев',
  'Мар',
  'Апр',
  'Май',
  'Июн',
  'Июл',
  'Авг',
  'Сен',
  'Окт',
  'Ноя',
  'Дек',
];

/* export const chartParams = {
  type: 'line',
  data: {
    datasets: [
      {
        data: [10, 20, 30, 40, 50, 60],
      },
    ],
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
  },
  options: options,
}; */
